import React, { useEffect, useState } from 'react';
import {
  Button,
  FlexDirectionRow,
  FormContainer,
  MainContent,
  SubTitle,
} from '../../../../../components/StyledComponents';
import Input from '../../../../../components/InputControlled';
import { useForm } from 'react-hook-form';
import { valueIsRequired } from '../../../../../utils/regex';
import { handleModalStatus } from '../../../../../utils/handleModalStatus';
import { BaSeDialogContext } from '@base/react';
import Spinner from 'react-spinner-material';
import { useApp } from '../../../../../context/app';
import { PerfilUsuarioService } from '../../../services/PerfilUsuarioService';
// import { formatDefaultValueSelectRemoveMask } from '../../../../../utils/mask';
import Select from '../../../../../components/Select';
import ufService from '../../../../../services/ufService';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { ImCheckboxChecked, ImCheckboxUnchecked } from 'react-icons/im';

import styles from './styles.module.scss';

export const IncluirListaUsuario = ({ onSelectPerfil }) => {
  const { setRenderIncludeScreen } = useApp();
  const { control, handleSubmit, formState, reset } = useForm({
    defaultValues: {
      cpf: '',
      perfil: '',
      nome: '',
      uf: '',
    },
  });
  const { isSubmitting } = formState;
  const { showModal } = React.useContext(BaSeDialogContext);

  const [dataUfs, setDataUfs] = useState();
  const [valuePerfil, setValuePerfil] = useState([]);
  const [userPerfil, setUserPerfil] = useState({});

  const handleGoHome = () => {
    setRenderIncludeScreen(false);
  };

  const handleCleanFields = () => {
    setUserPerfil({});
    setValuePerfil([]);
    reset();
  };

  const getDataUfs = async () => {
    await ufService
      .listar()
      .then((response) => {
        setDataUfs(
          response?.data?.map((uf) => uf?.sigla).filter((i) => i !== 'NA') ?? {}
        );
      })
      .catch((error) => {
        console.error(error);
      });
  };

  useEffect(() => {
    getDataUfs();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log('SelectedPerfil', userPerfil);

    // eslint-disable-next-line
  }, [userPerfil]);

  const submitForm = async (dataForm) => {
    const dataToSubmit = {
      // nome: formatDefaultValueSelectRemoveMask(dataForm.nome),
      nome: dataForm.nome,
      cpf: dataForm.cpf,
      uf: {
        sigla: dataForm.uf,
      },
      perfil: userPerfil.at(-1),
      ativo: false,
    };
    try {
      const response = await PerfilUsuarioService.saveLista(dataToSubmit);
      handleModalStatus({
        type: 'success',
        msgOnSuccess: 'Usuário adicionado com sucesso.',
        onCloseModal: handleGoHome,
        showModal,
      });
      return response;
    } catch (e) {
      if (
        e.response?.data?.message.includes('Já existe um usuário com esse nome')
      ) {
        handleModalStatus({
          type: 'hasExist',
          msgOnHasExist:
            'Este usuário já existe. É necessário que você defina um nome diferente para continuar.',
          showModal,
        });
      } else {
        handleModalStatus({
          type: 'error',
          showModal,
        });
      }
    }
  };

  return (
    <MainContent>
      <SubTitle color="#00ccff">
        <h3>Lista de usuário: Incluir</h3>
      </SubTitle>
      <FormContainer>
        <div style={{ flex: 1 }}>
          <Input
            name="cpf"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="CPF"
            maxLength={140}
            borderRadius="6px"
          />
          <div style={{ marginTop: '-1rem' }}>
            <label htmlFor="name">Perfil do usuário</label>
            <div className={styles.auto_complete_area}>
              <Autocomplete
                multiple
                size="small"
                id="checkboxes-tags-demo"
                options={onSelectPerfil?.content}
                disableCloseOnSelect
                getOptionLabel={(option) => option.nome}
                renderOption={(props, option, { selected }) => {
                  return (
                    <li {...props}>
                      <div style={{ marginRight: '0.5rem' }}>
                        {selected ? (
                          <ImCheckboxChecked />
                        ) : (
                          <ImCheckboxUnchecked />
                        )}
                      </div>

                      {option.nome}
                    </li>
                  );
                }}
                value={valuePerfil}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                onChange={(event, newValue) => {
                  setValuePerfil(newValue);

                  // return;
                  const addNewPerfil = [{ ...userPerfil }];
                  addNewPerfil.push(newValue);
                  setUserPerfil(addNewPerfil);
                }}
                style={{ width: '100%' }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    // label="Selecione"
                    variant="outlined"
                    placeholder="Selecione"
                  />
                )}
              />
            </div>
          </div>
          <Input
            name="nome"
            control={control}
            rules={{ ...valueIsRequired() }}
            placeholder="Nome do usuario"
            maxLength={140}
            borderRadius="6px"
          />
          <Select
            name="uf"
            placeholder="UF"
            options={dataUfs}
            control={control}
            rules={{ ...valueIsRequired() }}
            borderRadius="6px"
          />
        </div>

        <div style={{ flex: 1, paddingBottom: '1rem' }}>
          <FlexDirectionRow
            position={'end'}
            align={'end'}
            style={{
              marginRight: '40px',
              width: '100%',
              height: '100%',
            }}
          >
            <Button
              type="button"
              backgroundColor={'#9CA2A8'}
              onClick={() => handleCleanFields()}
              style={{
                marginRight: '20px',
              }}
            >
              Limpar
            </Button>

            <Button
              href="#"
              disabled={isSubmitting}
              onClick={handleSubmit(submitForm)}
            >
              {isSubmitting ? (
                <Spinner radius={5} color={'#fff'} stroke={2} visible={true} />
              ) : (
                'Incluir nome'
              )}
            </Button>
          </FlexDirectionRow>
        </div>
      </FormContainer>
    </MainContent>
  );
};
